import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FLOWCODE_MARKETING_BASE_URL } from '@dtx-company/true-common/src/constants/routes'
import { flowcodeNavLogo } from '@app/common/src/constants/assets'
import { mediaMaxWidth } from '@app/common/src/theme'
import Image from 'next/image'
import Link, { LinkProps } from 'next/link'
import events from '@dtx-company/inter-app/src/event-tracking/events/nav'
import styled from 'styled-components'

const LogoWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  a {
    display: inline-block;
    position: relative;
    height: 22px;
  }

  ${mediaMaxWidth.custom(840)} {
    img {
    }
    a {
      width: 118px;
      height: 18px;
    }
  }
`

export interface HeaderLogoProps {
  href?: LinkProps['href']
  isNextLink?: boolean
}

export function HeaderLogo({ isNextLink = false, href }: HeaderLogoProps): JSX.Element {
  const alt = 'Flowcode Logo'
  const logoImage = <Image src={flowcodeNavLogo} alt={alt} width={144} height={22} priority />

  return (
    <LogoWrapper>
      {isNextLink && href ? (
        <Link href={href} onClick={() => events.Global_Navigation_Clicked_FlowcodeLogo()}>
          {logoImage}
        </Link>
      ) : (
        <a
          href={href?.toString() || FLOWCODE_MARKETING_BASE_URL}
          rel="noopener noreferrer"
          onClick={() => events.Global_Navigation_Clicked_FlowcodeLogo()}
          aria-label="Flowcode homepage"
        >
          {logoImage}
        </a>
      )}
    </LogoWrapper>
  )
}
